/* eslint-disable tailwindcss/no-custom-classname */
import Image from "next/image";
import { useEffect } from "react";
import { useRouter } from "next/router";
// templates
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";
// hooks
import { useBudouX } from "@/hooks/useBudouX";
// molecules
import { ButtonLink, TLink } from "@/components/molecules/Button";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
// organisms
import Careers from "@/components/organisms/Careers";
// icons
import { faFaceSmileRelaxed } from "@fortawesome/pro-thin-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// Images
import coverContact from "/public/cover-contact.webp";
import leadContact from "/public/lead-contact.svg";
import leadContactH from "/public/lead-contactH.svg";

export default function ContactPage(props) {
  const router = useRouter();
  const { parse } = useBudouX();
  const isHeaderRelative = true;

  useEffect(() => {
    router.replace("/contact/form/");
  }, [router]);
  return (
    <>
      <Meta
        pageTitle={"お問い合わせ"}
        pageDescription={
          "株式会社トッカシステムズのお問い合わせです。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/contact/form/"}
      />
      <Layout>
        <Header isRelative={isHeaderRelative} />
        <main className="flex-1">
          <Container>
            <Inner className="relative box-border flex items-center justify-between gap-10 px-6 pt-10 pb-8 text-pri sm:px-8 md:px-12 md:py-10 lg:py-14">
              <div className="space-y-3">
                <h2 className="block max-w-[285px] md:max-w-fit">
                  <span className="hidden md:block">
                    <Image
                      src={leadContactH}
                      alt="Get in touch with ToccaSystems"
                      quality={80}
                    />
                  </span>
                  <span className="block md:hidden">
                    <Image
                      src={leadContact}
                      alt="Get in touch with ToccaSystems"
                      quality={80}
                    />
                  </span>
                </h2>
                <div className="text-base font-bold text-ter md:text-md">
                  {parse(
                    "システム構築のご相談やご依頼など、お悩みのことがあれば、お気軽にお問い合わせください。"
                  )}
                </div>
              </div>
              <h4 className="hidden text-sec md:block md:text-6xl lg:text-7xl">
                <FontAwesomeIcon icon={faFaceSmileRelaxed} />
              </h4>
            </Inner>
            <div className="relative aspect-2/1 w-full">
              <Image
                src={coverContact}
                alt=""
                quality={80}
                layout="fill"
                objectFit="cover"
              />
            </div>
            <Inner className="relative max-w-3xl space-y-4 py-8 px-6 sm:px-8 md:space-y-6 md:p-12 lg:py-16">
              <h3 className="text-lg font-bold text-pri">About Inquiries</h3>
              <div className="text-txt-base fluid-text-[14px,18px]">
                ToccaSystemsへのプロジェクト案件のご相談や、各種ご依頼、その他のお問い合わせは、下記リンクよりご連絡ください。担当者からご返信を差し上げます。
                <br />※
                <TLink href="/careers/" variant="light" color="pp">
                  採用に関する情報はこちら
                </TLink>
                をご覧ください。
                <br />※
                <TLink
                  href="/page/personal-info-purpose/"
                  variant="light"
                  color="pp"
                >
                  個人情報取得時の利用目的はこちら
                </TLink>
                をご覧ください。
                <br />
              </div>
              <ButtonLink
                href="https://forms.office.com/Pages/ResponsePage.aspx?id=fwHoS0CTlky73SDON9vQOpNDjghZlhxMnQm7H71CLJVUQkJVWVZHSzRaRVFGVzg3Qzc0WkJCNzJYWC4u"
                variant="solid"
                color="ter"
                className="h-16 w-full rounded-md"
                target="_blank"
                rel="noreferrer"
              >
                お問い合わせフォーム
              </ButtonLink>
            </Inner>
          </Container>
        </main>
        <Careers />
        <Footer />
      </Layout>
    </>
  );
}
